import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import './assets/css/main.scss';
import store from './store';
const app = createApp(App);

store.dispatch('loadConfig').then(() => {
    app.use(store);
    app.use(router);
    app.mount('#app');
}).catch((error) => {
    console.error('Error "config-front.json" file:', error);
});